import { observable, computed, action } from "mobx";
import {sumBy} from 'lodash';
export class Xp {
	@observable _shouldUpdate = false;

	@computed get updating(){
		return this._shouldUpdate;
	}

	@observable delay = 0;
	@observable duration = 0.5;

	@observable previousXp = 0;
	@observable previousXpStart = 0;
	@observable previousXpNext = 0;
	@observable previousLevel = 0;

	@computed get previousPercentage(){
		return (this.previousXp - this.previousXpStart) / (this.previousXpNext - this.previousXpStart) * 100;
	}

	@observable currentXp = 0;
	@observable currentXpStart = 0;
	@observable currentXpNext = 0;
	@observable currentLevel = 0;

	@computed get currentProgress(){
		return [this.currentXp - this.currentXpStart, this.currentXpNext - this.currentXpStart];
	}

	@computed get currentPercentage(){
		return (this.currentXp - this.currentXpStart) / (this.currentXpNext - this.currentXpStart) * 100;
	}

	@action.bound nextStep(delay = 0, duration = 0.5){
		// console.log('next step');
		this.delay = delay;
		this.duration = duration;
		this._shouldUpdate = true;

		this.previousXp = this.currentXp;
		this.previousXpNext = this.currentXpNext;
		this.previousXpStart = this.currentXpStart;
		this.previousLevel = this.currentLevel;

		if(this.currentLevel < this._target.level){
			if(this.currentXp < this.currentXpNext){
				this.currentXp = this.currentXpNext;
				return 'complete-lvl';
			} else {
				this.currentLevel++;
				//show the user back at 0%
				this.currentXpStart = 0;
				this.currentXp = 0;
				this.currentXpNext = 1;

				this.previousXpStart = 0;
				this.previousXp = 0
				this.previousXpNext = 1;
				return 'increment-lvl';
			}
		} else if(this.currentXp < this._target.xp){
			this.currentXp = this._target.xp;
			this.currentXpStart = this._target.start;
			this.currentXpNext = this._target.next;
			return 'update-xp'
		}
		return 'xp-current';
	}

	//used to set values immediately to the completed state.
	@action.bound setComplete(){
		this.currentXp = this._target.xp;
		this.currentXpNext = this._target.next;
		this.currentXpStart = this._target.start;
		this.currentLevel = this._target.level;

		this.previousXp = this.currentXp;
		this.previousXpNext = this.currentXpNext;
		this.previousXpStart = this.currentXpStart;
		this.previousLevel = this.currentLevel;
	}

	@observable _target = {
		xp: 0,
		level: 0,
		start: 0,
		next: 0
	}

	@action.bound updateFromServer(data, immediate){
		this._target.xp = sumBy(data.Progress, 'Quantity');
		this._target.next = sumBy(data.Next, 'Quantity');
		this._target.start = sumBy(data.Start, 'Quantity');
		this._target.level = data.Current.Quantity;

		if(immediate){
			this.setComplete();
		}
		// console.log(window.toJS(this))
	}
}
